<template>
  <div class="pro-badge-cont" @click="show_pricing_compare_modal">
    <div class="pro-badge">
      <strong>Premium feature<i>Learn more</i></strong>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PremiumInfoBadge",
  props: {
    highlight_feature: {
      type: String
    }
  },
  methods: {
    show_pricing_compare_modal() {
      this.event_bus.$emit(
        "show-pricing-compare-modal",
        this.highlight_feature
      );
    }
  }
};
</script>
